import { useTu } from "@src/appV2/i18n/useTu";
import { Button, type SxProps, type Theme } from "@mui/material";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getLocation } from "../../utils/routes";
import type { AdminChatMessage, PlacementChannelMetadata } from "../types";
import { parseCustomMessage } from "../utils/parseCustomMessage";
import { ChatMessageCard } from "./ChatMessageCard";

interface PlacementApplicationInterviewScheduledProps {
  message: AdminChatMessage;
  channelMetadata?: PlacementChannelMetadata;
  sx?: SxProps<Theme>;
}

export function PlacementApplicationInterviewScheduled(
  props: PlacementApplicationInterviewScheduledProps
) {
  const { tu } = useTu("chat");

  const { message, channelMetadata, sx } = props;
  const history = useHistory();
  const displayMessage = parseCustomMessage(message.message);

  const navigateToManageJobsPage = useCallback(() => {
    history.push(
      getLocation("manageJobs", {
        queryParams: channelMetadata?.hcpName ? { searchApplicant: channelMetadata.hcpName } : {},
      })
    );
  }, [history, channelMetadata?.hcpName]);

  return (
    <ChatMessageCard
      actions={
        <Button size="small" variant="contained" onClick={navigateToManageJobsPage}>
          {tu("Manage jobs")}
        </Button>
      }
      title={displayMessage}
      sx={sx}
    />
  );
}
